import { directAxiosInstance } from "@lib/api"

export const addMedicineSku = (payload, navigate) => {
    return directAxiosInstance()
        .post(`/api/v4/carts/skus`, payload)
        .then((res) => {
            navigate("/cart")
            return Promise.resolve(res)
        })
        .catch((error) => {
            navigate("/404")
            return Promise.reject(error)
        })
}
